export const RQ_GET_DML_REPORT_API = {
  url: 'reports/customer/dml/<%= divisionId %>',
  method: 'GET',
  auth: true,
};
